<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div class="card custom-card col-xl-12 rounded-0 border-0 shadow">
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-user-friends"></i>
								Staff Off Boarding&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-handshake"
												></i
												>&nbsp;&nbsp;Reservation&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Staff Off Boarding&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</content>
</template>

<script>
export default {};
</script>



